import { Components, Theme } from "@mui/material";
import type {} from "@mui/x-data-grid-pro/themeAugmentation";

export const MuiDataGrid: Components<Theme>["MuiDataGrid"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: "none",

      "--DataGrid-pinnedBackground": "white",
      "--unstable_DataGrid-radius": "1rem",

      ".MuiDataGrid-scrollbar": {
        scrollbarColor: `${theme.palette.primary.main} ${theme.palette.grey[100]}`,
        scrollbarWidth: "thin",
      },

      "& .MuiPopper-root .MuiPaper-root": {
        boxShadow: theme.shadows[8],
      },
    }),
    columnHeaderTitle: ({ theme }) => ({
      color: theme.palette.primary.dark,
    }),
    cell: ({ theme }) => ({
      alignContent: "center",

      "& .MuiIconButton-root[aria-haspopup=menu]": {
        backgroundColor: theme.palette.grey[300],

        "&:hover": {
          backgroundColor: theme.palette.grey[500],
        },
      },
    }),
  },
};

export const MuiTablePagination: Components<Theme>["MuiTablePagination"] = {
  styleOverrides: {
    root: {},
    selectLabel: {
      margin: 0,
    },
    displayedRows: {
      margin: 0,
    },
  },
};
